import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addNewsLetterData } from "services/_newsLetter";
import { successToast, errorToast } from "components/toast";

const Newsletter = () => {
  const handleSubmit = async (values, { resetForm }) => {
    const response = await addNewsLetterData(values);
    if (response.isSuccess) {
      successToast(response.message);
      resetForm();
    } else {
      errorToast(response.message);
    }
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      )
      .required("Email is required"),
  });

  return (
    <section className=" p-[20px] newsletter  mx-auto py-[15px] bg-[#fff] rounded-[15px] ">
      <div className="container min-h-[240px]   rounded-[15px] bg-[#fff9ea] p-[25px] ">
        <h1 className="font-bold heading text-[36px] text-center text-[var(--text-color)] mt-0">
          Join Our Newsletter
        </h1>

        <p
          className="w-full mx-auto mt-[10px]   !text-[#000] md:text-[16px] text-[14px]"
          style={{ fontWeight: "initial" }}
        >
          Subscribe to our newsletter to receive updates about diagnosis and
          treatment options for axial spondyloarthritis
        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form className="max-w-[600px mt-[25px]">
              <div className="search_box flex max-w-[600px]   w-[100%]   h-[45px] rounded-[7px] relative">
                <Field
                  type="text"
                  name="email"
                  id="email"
                  className="border-0 !text-[#000D44]  h-[45px] bg-[#fff] px-[15px] max-w-[350px] w-full"
                  placeholder="Enter your Email address"
                />
                <button
                  type="submit"
                  className=" bg-[#000D44] h-[45px] !text-white !rounded-none  ml-[-10px] px-[40px]"
                >
                  Subscribe
                </button>
              </div>
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default Newsletter;
